import { FormattedMessage, injectIntl } from "react-intl";
import {
  ActionBar,
  Details,
  displayUserName,
  DetailsItem,
  userShape,
} from "lcm-iot-commons";

type OwnProps = {
  user?: userShape;
};

const defaultProps: Partial<OwnProps> = {
  user: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function UserDetailsItem({ user }: Props) {
  return user ? (
    <div className="user-detail-item">
      <ActionBar>
        <h2 id="permission-request-user-header">
          <FormattedMessage id="label.user" />
        </h2>
      </ActionBar>
      <Details>
        <DetailsItem
          id="user-name"
          translationKey="label.name"
          value={displayUserName(user)}
        />
        <DetailsItem
          id="user-email"
          translationKey="label.email"
          value={(user as $TSFixMe).email}
        />
      </Details>
    </div>
  ) : null;
}

UserDetailsItem.defaultProps = defaultProps;

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(UserDetailsItem);
